<template>
    <div>
        <!-- Section: Tarefa será executada por -->
        <v-row>
            <v-col cols="12" sm="6" md="4" v-if="isFieldVisible('cliente')">
                <v-select
                    :value="empresaValue"
                    @input="$emit('update:empresa', $event)"
                    :items="clientes"
                    :item-text="'nome_cliente'"
                    :item-value="'id_cliente'"
                    :label="$t('ticket.createDialog.fields.cliente')"
                    :rules="[(v) => !!v || ($t('ticket.createDialog.fields.validation.cliente'))]"
                    :disabled="clienteSelectDisabled"
                    :clearable="!clienteSelectDisabled"
                ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="4" v-if="isFieldVisible('id_local_empresa')">
                <v-select
                    :value="value.id_local_empresa"
                    @input="onLocalEmpresaChange($event)"
                    :items="locaisEmpresa"
                    item-text="nome_local"
                    item-value="id_local"
                    :label="$t('ticket.createDialog.fields.localEmpresa')"
                    :disabled="!empresaValue"
                    :loading="loadingLocais"
                    clearable
                ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="4" v-if="isFieldVisible('nome_usuario_solicitante')">
                <v-layout align-center>
                    <v-flex>
                        <v-autocomplete
                            :value="value.nome_usuario_solicitante"
                            @input="onClaimantChange($event)"
                            :items="claimantOptions"
                            item-text="nome_usuario"
                            item-value="nome_usuario"
                            :label="$t('ticket.createDialog.fields.claimant')"
                            :search-input.sync="claimantSearch"
                            :loading="loadingClaimantUsuarios"
                            no-filter
                            clearable
                        ></v-autocomplete>
                    </v-flex>
                    <v-btn
                        v-if="currentUser && currentUser.nome_usuario"
                        icon
                        small
                        :title="$t('ticket.createDialog.fields.useLoggedUserAsClaimant')"
                        @click="useCurrentUserAsClaimant"
                    >
                        <v-icon small>mdi-account-arrow-right</v-icon>
                    </v-btn>
                </v-layout>
            </v-col>
            <v-col cols="12" sm="6" md="4" v-if="isFieldVisible('nome_usuario_solicitante')">
                <v-text-field
                    :value="value.telefone_solicitante"
                    @input="updateField('telefone_solicitante', $event)"
                    :label="$t('ticket.createDialog.fields.telefoneSolicitante')"
                    type="tel"
                    clearable
                ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4" v-if="isFieldVisible('titulo')">
                <v-text-field
                    :value="value.titulo"
                    @input="updateField('titulo', $event)"
                    :label="$t('ticket.createDialog.fields.titulo')"
                    :rules="[(v) => !!v || $t('ticket.createDialog.fields.validation.titulo')]"
                ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4" v-if="!hideTipoTicketField && isFieldVisible('id_tipo_ticket')">
                <v-select
                    :value="value.id_tipo_ticket"
                    @input="onTipoTicketChange($event)"
                    :items="tiposTickets"
                    item-text="nome_tipo_ticket"
                    item-value="id_tipo_ticket"
                    :label="$t('ticket.createDialog.fields.tipoTicket.label')"
                    clearable
                ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="4" v-if="isFieldVisible('dataHoras')">
                <v-datetime-picker
                    :label="$t('ticket.createDialog.fields.dataHoras')"
                    v-model="dateTimePickerModel"
                    :text-field-props="dateTimeTextFieldProps"
                    :date-picker-props="dateTimeDatePickerProps"
                    :time-picker-props="dateTimeTimePickerProps"
                    time-format="HH:mm"
                    date-format="dd/MM/yyyy"
                    :clear-text="$t('datetime.close')"
                >
                    <template slot="dateIcon">
                        <v-icon>mdi-calendar</v-icon>
                    </template>
                    <template slot="timeIcon">
                        <v-icon>mdi-clock</v-icon>
                    </template>
                </v-datetime-picker>
            </v-col>
        </v-row>

        <!-- Main Field: Descrição da tarefa -->
        <v-row>
            <v-col cols="12" v-if="isFieldVisible('corpo')">
                <v-textarea
                    :value="value.corpo"
                    @input="updateField('corpo', $event)"
                    :label="$t('ticket.createDialog.fields.descricaoTarefa')"
                    rows="4"
                    counter="500"
                    :maxlength="500"
                ></v-textarea>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import apiController from '@/utils/apiController';
import { mapGetters } from 'vuex';

export default {
    name: 'TicketCreateGeralFields',
    props: {
        screen: {
            type: String,
            default: null
        },
        value: {
            type: Object,
            required: true
        },
        checklists: {
            type: Array,
            default: () => []
        },
        empresas: {
            type: Array,
            default: () => []
        },
        clientes: {
            type: Array,
            default: () => []
        },
        useClientes: {
            type: Boolean,
            default: true
        },
        empresaValue: {
            type: [Number, String],
            default: null
        },
        clienteSelectDisabled: {
            type: Boolean,
            default: false
        },
        displayDate: {
            type: String,
            default: null
        },
        displayTime: {
            type: String,
            default: null
        },
        showDateTimeFields: {
            type: Boolean,
            default: false
        },
        tiposTickets: {
            type: Array,
            default: () => []
        },
        hideTipoTicketField: {
            type: Boolean,
            default: false
        },
        currentUser: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            claimantSearch: '',
            claimantUsuarios: [],
            loadingClaimantUsuarios: false,
            claimantRequestId: 0,
            locaisEmpresa: [],
            loadingLocais: false,
            dateTimeTextFieldProps: {},
            dateTimeDatePickerProps: {},
            dateTimeTimePickerProps: {}
        };
    },
    computed: {
        ...mapGetters('config', ['ticketCamposCriacaoForScreen']),
        visibleFieldsList() {
            if (!this.screen) return [];
            return this.ticketCamposCriacaoForScreen(this.screen) || [];
        },
        /**
         * ticket_campos_criacao liga/desliga campos; agendamento também depende da permissão de quem cria.
         * Família, tipo de solicitação/atendimento, serviço, grupo solucionador, colaborador e
         * "Compartilhar com" ficam só na edição do card: o ticket nasce Pendente.
         */
        isFieldVisible() {
            return (key) => {
                if (key === 'dataHoras' && !this.showDateTimeFields) return false;
                if (this.visibleFieldsList.length === 0) return true;
                return this.visibleFieldsList.includes(key);
            };
        },
        displayDateTimeValue() {
            const d = this.displayDate || '';
            const t = this.displayTime || '00:00';
            if (!d) return '';
            return `${d}T${t}`;
        },
        dateTimePickerModel: {
            get() {
                if (!this.displayDate) return null;
                const dateStr = this.displayDate;
                const timeStr = (this.displayTime || '00:00').substring(0, 5);
                return new Date(dateStr + 'T' + timeStr + ':00');
            },
            set(val) {
                if (!val) {
                    this.$emit('update:displayDate', null);
                    this.$emit('update:displayTime', null);
                    return;
                }
                const d = val instanceof Date ? val : new Date(val);
                const y = d.getFullYear();
                const m = String(d.getMonth() + 1).padStart(2, '0');
                const day = String(d.getDate()).padStart(2, '0');
                const h = String(d.getHours()).padStart(2, '0');
                const min = String(d.getMinutes()).padStart(2, '0');
                this.$emit('update:displayDate', `${y}-${m}-${day}`);
                this.$emit('update:displayTime', `${h}:${min}`);
            }
        },
        claimantOptions() {
            const carregados = Array.isArray(this.claimantUsuarios) ? this.claimantUsuarios : [];
            const atual = this.value && this.value.nome_usuario_solicitante;
            const base = atual && !carregados.some(u => (u.nome_usuario || '') === atual)
                ? [{ nome_usuario: atual }].concat(carregados)
                : carregados;
            const search = (this.claimantSearch || '').trim();
            if (!search) {
                return base;
            }
            const exists = base.some(
                u => (u.nome_usuario || '').toLowerCase() === search.toLowerCase()
            );
            if (exists) {
                return base;
            }
            return [{ nome_usuario: search }].concat(base);
        }
    },
    mounted() {
        if (this.screen) {
            this.$store.dispatch('config/fetchTicketCamposCriacao');
        }
        this.fetchClaimantUsuarios('');
    },
    watch: {
        claimantSearch(val) {
            this.fetchClaimantUsuarios(val);
        },
        empresaValue(idEmpresaOuCliente) {
            this.locaisEmpresa = [];
            if (!idEmpresaOuCliente) {
                this.$emit('input', { ...this.value, id_local_empresa: null, endereco: null });
                return;
            }
            this.loadingLocais = true;
            const endpoint = this.useClientes
                ? apiController.endpoints.getLocaisporcliente
                : apiController.endpoints.getLocaisporempresa;
            apiController.request(endpoint, {
                params: { id: idEmpresaOuCliente },
                silent: true,
                onSuccess: (response) => {
                    const all = response.data || [];
                    this.locaisEmpresa = all.filter(l => l.ativo === 1 || l.ativo === '1');
                    const payload = { ...this.value, id_local_empresa: null, endereco: null };
                    if (this.useClientes && this.locaisEmpresa.length > 0) {
                        const defaultLocal = this.locaisEmpresa.find(l => l.is_default === 1 || l.is_default === '1');
                        if (defaultLocal) {
                            payload.id_local_empresa = defaultLocal.id_local;
                            payload.endereco = defaultLocal.endereco || defaultLocal.nome_local || null;
                        }
                    }
                    this.$emit('input', payload);
                    this.loadingLocais = false;
                },
                onError: () => {
                    this.locaisEmpresa = [];
                    this.$emit('input', { ...this.value, id_local_empresa: null, endereco: null });
                    this.loadingLocais = false;
                },
            });
        }
    },
    methods: {
        updateField(field, value) {
            this.$emit('input', { ...this.value, [field]: value });
        },
        /** Sugestoes do solicitante vindas do endpoint lazy (nunca a base inteira de usuarios). */
        fetchClaimantUsuarios(searchVal) {
            const requestId = ++this.claimantRequestId;
            this.loadingClaimantUsuarios = true;
            apiController.request(apiController.endpoints.getUsuarioslazy, {
                data: {
                    page: 1,
                    pageSize: 10,
                    search: searchVal == null ? '' : String(searchVal),
                    includeTotal: false
                },
                silent: true,
            }).then((response) => {
                if (requestId !== this.claimantRequestId) return;
                const data = response.data || {};
                this.claimantUsuarios = Array.isArray(data.items) ? data.items : [];
            }).catch(() => {
                if (requestId !== this.claimantRequestId) return;
                this.claimantUsuarios = [];
            }).finally(() => {
                if (requestId !== this.claimantRequestId) return;
                this.loadingClaimantUsuarios = false;
            });
        },
        onClaimantChange(nomeUsuario) {
            const list = Array.isArray(this.claimantUsuarios) ? this.claimantUsuarios : [];
            const user = list.find(u => (u.nome_usuario || '') === (nomeUsuario || ''));
            const telefone = user && (user.telefone != null && user.telefone !== '') ? user.telefone : null;
            this.$emit('input', {
                ...this.value,
                nome_usuario_solicitante: nomeUsuario || null,
                // Sem telefone no item escolhido, preserva o que ja estiver digitado.
                telefone_solicitante: telefone != null ? telefone : (this.value.telefone_solicitante || null)
            });
        },
        useCurrentUserAsClaimant() {
            if (!this.currentUser || !this.currentUser.nome_usuario) return;
            const telefone = this.currentUser.telefone != null && this.currentUser.telefone !== '' ? this.currentUser.telefone : null;
            this.$emit('input', {
                ...this.value,
                nome_usuario_solicitante: this.currentUser.nome_usuario,
                telefone_solicitante: telefone
            });
        },
        onTipoTicketChange(value) {
            this.updateField('id_tipo_ticket', value);
        },
        onLocalEmpresaChange(id_local) {
            const loc = id_local ? (this.locaisEmpresa || []).find(l => l.id_local === id_local) : null;
            const endereco = loc ? (loc.endereco || loc.nome_local || '') : null;
            this.$emit('input', { ...this.value, id_local_empresa: id_local, endereco });
        }
    }
};
</script>
